import { createRouter, createWebHistory } from 'vue-router'
import Home from '../pages/Home.vue'
import Expense from '../pages/Expense.vue'
import NewExpense from '../pages/NewExpense.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/expense/new',
    name: 'expense-new',
    component: NewExpense
  },
  {
    path: '/expense/:id',
    name: 'expense',
    component: Expense
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
